import { getDraftMeetingStatusOptions } from "@/utils/draftCalendarFields";

export interface BulkEditRoleContext {
  isBusinessApprover: boolean;
  isBusinessReviewer: boolean;
}

export interface BulkEditPermissions {
  /** Whether the Admin section (Tier, Show In GRC) is visible */
  canViewAdminSection: boolean;
  /** Whether the user can change the Show In GRC value */
  canEditShowInGRC: boolean;
  /** Whether the user can change the Tier field */
  canEditTier: boolean;
  /** Available draft meeting status options for this role */
  draftMeetingStatusOptions: string[];
}

export function getBulkEditPermissions(ctx: BulkEditRoleContext): BulkEditPermissions {
  const isRestricted = ctx.isBusinessApprover || ctx.isBusinessReviewer;

  return {
    canViewAdminSection: !isRestricted,
    canEditShowInGRC: !isRestricted,
    canEditTier: !isRestricted,
    draftMeetingStatusOptions: getDraftMeetingStatusOptions(ctx.isBusinessApprover, ctx.isBusinessReviewer),
  };
}
